/**
 * Shared constants for chart reference bands. The default matches
 * DEFAULT_REFERENCE_BAND_COLOR in api/Sandbox/schema.py.
 */
export const DEFAULT_REFERENCE_BAND_COLOR = "#C9E4F8";

/** Pastel swatches offered in the band color picker. Bands sit behind the data, so they stay light. */
export const REFERENCE_BAND_PRESET_COLORS = [
  { color: "#F8C9C9", title: "Pastel Red" },
  { color: "#FFD8B5", title: "Peach" },
  { color: "#FFF3B0", title: "Pastel Yellow" },
  { color: "#CDEFD1", title: "Mint" },
  { color: "#C9E4F8", title: "Sky" },
  { color: "#DCD3F5", title: "Lavender" },
  { color: "#F9D5E5", title: "Pink" },
  { color: "#E4E4E4", title: "Light Grey" },
];
